var _rect, _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSeries = function SvgSeries(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#4467F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.98 29.993h-18c-.6 0-.999-.4-.999-1v-16c0-.6.4-1 1-1h18c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1Z",
    fill: "url(#series_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.98 13.994c-.6 0-1-.4-1-1v-2c0-.6.4-1 1-1s1 .4 1 1v2c0 .6-.4 1-1 1Zm5-1v-2c0-.6-.4-1-1-1s-1 .4-1 1v2c0 .6.4 1 1 1s1-.4 1-1Zm4 0v-2c0-.6-.4-1-1-1s-1 .4-1 1v2c0 .6.4 1 1 1s1-.4 1-1Zm4 0v-2c0-.6-.4-1-1-1s-1 .4-1 1v2c0 .6.4 1 1 1s1-.4 1-1Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.781 21.093c.4 0 .7-.1.9-.3.2-.2.4-.5.4-.9 0-.3-.1-.6-.3-.8-.2-.2-.5-.3-.8-.3-.2 0-.4 0-.6.1-.2.1-.3.2-.4.3-.1.1-.2.2-.3.4-.1.2-.2.3-.2.5 0 .1-.1.1-.2.2s-.2.1-.4.1-.3-.1-.4-.2c-.1-.1-.2-.3-.2-.5s.1-.4.2-.6c.1-.2.3-.4.5-.6.2-.2.5-.4.9-.5.4-.1.7-.2 1.2-.2.4 0 .7.1 1 .2.3.1.6.3.8.4.2.1.4.4.5.7.1.3.2.5.2.8 0 .4-.1.7-.3 1-.2.3-.4.6-.7.8.3.2.6.4.8.6.2.2.4.4.5.7.1.3.2.5.2.8 0 .4-.1.7-.2 1-.1.3-.4.6-.6.9-.2.3-.6.5-1 .6-.4.1-.8.2-1.3.2s-.9-.1-1.3-.3c-.4-.2-.7-.4-.9-.6-.2-.2-.4-.5-.5-.8-.1-.3-.2-.5-.2-.7 0-.2.1-.4.2-.5.1-.1.3-.2.5-.2.1 0 .2 0 .3.1.1.1.2.1.2.2.2.5.4.9.7 1.2.3.3.6.4 1 .4.2 0 .5-.1.7-.2.2-.1.4-.3.6-.5.2-.2.2-.5.2-.8 0-.5-.1-.8-.4-1.1-.3-.3-.6-.4-1-.4h-.7c-.2 0-.4-.1-.5-.2-.1-.1-.2-.3-.2-.4 0-.2.1-.3.2-.5s.3-.2.6-.2h.3v.1Zm6.5 4.4v-5.3c-1 .8-1.7 1.1-2 1.1-.2 0-.3-.1-.4-.2-.1-.1-.2-.3-.2-.5s.1-.3.2-.4c.1-.1.3-.2.7-.4.5-.2.9-.5 1.1-.7l.8-.8c.3-.3.4-.5.4-.6 0-.1.2-.1.4-.1s.4.1.5.2c.1.1.2.4.2.7v6.7c0 .8-.3 1.2-.8 1.2-.2 0-.4-.1-.6-.2-.2-.1-.3-.4-.3-.7Z",
    fill: "url(#series_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "series_svg__a",
    x1: 19.981,
    y1: 11.993,
    x2: 19.981,
    y2: 29.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "series_svg__b",
    x1: 19.531,
    y1: 17.593,
    x2: 19.501,
    y2: 28.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};

export default SvgSeries;